
import {TweenMax, Cubic} from 'gsap'

class GradientWipe {

  constructor (x = 0, y = 1) {

    this.x = x
    this.y = y

    this.canvas = document.createElement('canvas')
    this.canvas.width = window.innerWidth
    this.canvas.height = window.innerHeight

    this.ctx = this.canvas.getContext('2d')

    let w = window.innerWidth
    let h = window.innerHeight
    this.maxR = Math.pow(w * w + h * h, 0.5)

    this.currColor = 'rgba(255,255,255,0)'

    return this
  }

  drawGradient (toColor, percent) {

    let w = window.innerWidth
    let h = window.innerHeight

    this.ctx.clearRect(0, 0, w, h)

    // let grd = this.ctx.createRadialGradient(
    //   0,
    //   this.ctx.canvas.height,
    //   0,
    //   0,
    //   this.ctx.canvas.height,
    //   this.maxR * 30
    // )
    let grd = this.ctx.createRadialGradient(
      this.x * w,
      this.y * h,
      0,
      this.x * w,
      this.y * h,
      this.maxR * 30
    )
    grd.addColorStop(0, toColor)
    grd.addColorStop(percent, this.currColor)

    this.ctx.fillStyle = grd
    this.ctx.fillRect(0, 0, window.innerWidth, window.innerHeight)

  }

  draw (color, time = 1.2, onUpdate) {

    let w = window.innerWidth
    let h = window.innerHeight

    this.canvas.width = w
    this.canvas.height = h

    this.ctx = this.canvas.getContext('2d')
    this.ctx.canvas.width = w
    this.ctx.canvas.height = h

    this.maxR = Math.pow(w * w + h * h, 0.5)


    if (this.tween) this.tween.kill()

    return new Promise((resolve)=> {
      this.tween = TweenMax.to({value: 0}, time, {
        value: 1,
        ease: Cubic.easeIn,
        onUpdateParams: ['{self}'],
        onUpdate: (tween)=> {
          this.drawGradient(color, tween.target.value)
          if (onUpdate) onUpdate(tween)
        },
        onComplete: ()=> {
          this.currColor = color
          resolve()
        }
      })
    })


  }

}

export default GradientWipe




// WEBPACK FOOTER //
// ./src/components/game/result/GradientWipe.js